var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 23.3 23.3",
    style: {
      enableBackground: "new 0 0 23.3 23.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#2A275C;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.8,23.3H2.5c-1.4,0-2.5-1.1-2.5-2.5V2.5C0,1.1,1.1,0,2.5,0h18.4c1.4,0,2.5,1.1,2.5,2.5v18.4 C23.3,22.2,22.2,23.3,20.8,23.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.2,8.8c-0.2-1.1-0.7-1.6-1.8-1.7C15.7,7,14.9,7,14.1,6.9c-0.1,0-0.2,0-0.2,0H9.4c-0.1,0.1-0.1,0-0.2,0 C8.4,7,7.6,7,6.8,7.1c-1,0.1-1.5,0.6-1.7,1.6c0,0.5-0.1,1-0.1,1.6c0,0.1,0,0.1,0,0.2v2.3c0.1,0,0,0.1,0,0.2c0,0.6,0.1,1.2,0.2,1.8 c0.2,0.7,0.7,1.2,1.4,1.4c0.3,0.1,0.7,0.1,1,0.1c1.5,0.1,3,0.1,4.5,0.1s3,0,4.4-0.2c0.9-0.1,1.4-0.6,1.6-1.5 c0.1-0.5,0.1-1.1,0.2-1.6C18.4,11.6,18.4,10.2,18.2,8.8 M10.4,13.6v-4c1.2,0.7,2.3,1.3,3.5,2C12.7,12.3,11.5,12.9,10.4,13.6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube_icon.c869e1b497a7b241abcd5b4034ea08cd.svg";
export { ForwardRef as ReactComponent };